import { useEffect, useRef, useState } from "react";
import OMSDropDownCard from "./OMSDropDownCard";
import { CLASS_NAME } from "../../../../features/deal/common/constants";

const OMSButtonDropDown = ({
  btnText,
  dropdownList,
  onClickDropdown,
  buttonClassName,
}) => {
  const [open, setOpen] = useState(false);
  const refButtonDropdown = useRef(null);

  useEffect(() => {
    const handleButtonClick = (e) => {
      if (
        refButtonDropdown.current &&
        !refButtonDropdown.current.contains(e.target)
      ) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };

    document.addEventListener("touchStart", handleButtonClick);
    document.addEventListener("click", handleButtonClick);
    return () => {
      document.removeEventListener("touchStart", handleButtonClick);
      document.removeEventListener("click", handleButtonClick);
    };
  }, []);
  // const handleToggleDropdown = (isToggle) => {
  //   setOpen(isToggle);
  // };

  return (
    <>
      <div className="relative m-4 btn-right">
        <a
          ref={refButtonDropdown}
          className={buttonClassName}
          onClick={() => {
            setOpen((isOpen) => !isOpen);
          }}
          onTouchStart={() => {
            setOpen(true);
          }}
        >
          {btnText}
        </a>
        {open && (
          <OMSDropDownCard
            data={dropdownList}
            onClick={onClickDropdown}
          // toggleDropdown={handleToggleDropdown}
          ></OMSDropDownCard>
        )}
      </div>
    </>
  );
};



export default OMSButtonDropDown;


export function OMSButtonDropDown2({
  label = "",
  dropdownOptions = [],
  currentId = "",
  onChange = () => { }
}) {
  return (
    <div className="dropdown">
      <span
        className="btn dropdown-toggle text-light cursor-pointer"
        data-toggle="dropdown"
      >
        {" "}
        {label}
        {"   "}
        <b className="caret"></b>
      </span>
      <ul className="dropdown-menu">
        {dropdownOptions?.map((curElem, i) => {
          return (
            <li
              key={curElem.Value}
              className={currentId === curElem.Value ? CLASS_NAME.ACTIVE + " " + CLASS_NAME.DROPDOWN_MENU_LINK : CLASS_NAME.DROPDOWN_MENU_LINK}
              onClick={() =>
                onChange(curElem.Value, curElem.Text)
              }
            >
              <a>{curElem.Text}</a>
            </li>
          );
        })}
      </ul>
    </div>
  )
}